import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

export interface GetTableViewColumnsRequestParams {
  GridName?: string;
}

export interface TableViewColumnOption {
  fieldReferenceName: string;
  fieldReferenceValue: string;
}

export const getTableViewColumnsAPI = (
  params: GetTableViewColumnsRequestParams = { GridName: 'LossAndDamageClaims' },
) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SECURITY}/GetGridColumnOptions`,
  });
};

export type TableViewColumnsResponse = TableViewColumnOption[];

export const fetchTableViewColumns = async (
  params?: GetTableViewColumnsRequestParams,
): Promise<TableViewColumnsResponse> => {
  const response: AxiosResponse<TableViewColumnsResponse> = await getTableViewColumnsAPI(params);
  return response.data;
};

export interface SaveTableViewColumnsData {
  columnOptions: Array<{
    fieldReferenceName: string;
    fieldReferenceValue: string;
  }>;
  gridName: string;
}

export const saveTableViewColumnsAPI = (data: SaveTableViewColumnsData) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.SECURITY}/SaveGridColumnOption`,
  });
};

export type SaveTableViewColumnsResponse = void;

export const saveTableViewColumns = async (data: SaveTableViewColumnsData): Promise<SaveTableViewColumnsResponse> => {
  const response: AxiosResponse<SaveTableViewColumnsResponse> = await saveTableViewColumnsAPI(data);
  return response.data;
};
